import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Categories() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            赛事分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">覆盖全球上百个体育项目，每日超千场赛事任您选择</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/80 rounded-lg p-6 text-center hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">{cat.description}</p>
              <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full">
                {cat.matchCount.toLocaleString()}+ 场赛事
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}